export default "__VITE_ASSET__ca4ed088__"